import { useTranslation } from "react-i18next";

import { useSuspenseQuery } from "@tanstack/react-query";

import { useVenue } from "../../VenueContext";
import { getVenueHasMobileOrdering } from "../../venueSelectors";
import { useCurrentCartUuid } from "../Session/SessionContext";
import { PendingCartItem } from "./PendingCartItem";
import { CartQueries } from "./queries";

export const CartItems = ({
  soldOutItemsUuids = [],
}: {
  soldOutItemsUuids?: string[];
}) => {
  const cartUuid = useCurrentCartUuid();
  const cart = useSuspenseQuery(CartQueries.cart(cartUuid)).data;
  const orderingEnabled = getVenueHasMobileOrdering(useVenue());
  const { t } = useTranslation();
  return (
    <div className="space-y-12">
      <h3 className="text-center text-2xl font-bold">
        {orderingEnabled ? t("cart.yourOrder") : t("cart.yourWishlist")}
      </h3>
      {cart.items.length > 0 ? (
        cart.items.map((cartItem) => (
          <PendingCartItem
            key={cartItem.id}
            cartItem={cartItem}
            inSoldOutError={soldOutItemsUuids.includes(cartItem.itemId)}
          />
        ))
      ) : (
        <div className="py-24 text-center text-lg font-medium">
          {t("cart.noPendingOrders")}
        </div>
      )}
    </div>
  );
};
